<template>
  <b-modal
      v-model="selectEmailModal"
      centered
      size="xl"
      title="Sélectionner un email automatique"
      body-class="email"
  >
    <h-fe-template-email v-model="actualEmail" :limit-to-category="limitToCategory"
                         :limit-to-service="limitToService"></h-fe-template-email>
    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end">
        <h-b-action
            :positive="false"
            text="Annuler"
            @click.native="selectEmailModal = false"
        ></h-b-action>
        <h-b-action
            :positive="true"
            class="ml-2"
            text="Associer le mail sélectionné"
            @click.native="handleAddEmail"
        ></h-b-action>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "template-email",

  props: {
    value: String,
    limitToService: {
      type: String,
      default: ''
    },
    limitToCategory: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      selectEmailModal: false,
      actualEmail: null,
    }
  },

  watch: {
    value: function () {
      this.actualEmail = this.value;
    },

    actualEmail: function () {
      this.$emit('input', this.actualEmail);
    }
  },

  methods: {
    handleAddEmail() {
      this.$emit('add');
      this.selectEmailModal = false;
    },

    managePopupOpen() {
      this.selectEmailModal = !this.selectEmailModal;
    }
  }
}
</script>

<style scoped>

</style>